/**
 * The signed-in admin, plus the two things the legacy layout hangs the whole side
 * menu off: the role set and the licensed feature sets.
 *
 * Values come from RawamDemo.sql — `rawamadmin` (Profiles + AspNetUserRoles) and the
 * Settings table. Swap this for the session bootstrap call when the API lands; the
 * shape already mirrors what `_AdminsBaseLayout` reads off `User` and `ViewBag`.
 */

import { localize } from '../lib/i18n'

export const session = localize({
  /** ViewBag.username — the display name the topbar shows. */
  username: 'Wajdy Essam Ahmed',
  /** The account name, which is what the profile page loads by. */
  login: 'rawamadmin',
  userId: '4077e2c3-989f-49d7-ac04-485b8cbde772',
  email: 'user1@example.invalid',
  company: 'COEIA',

  /** AspNetUserRoles for rawamadmin — no SystemManagers, no CertificateValiditionManagers. */
  roles: [
    'StatisticsManagers',
    'UsersManagers',
    'ContentManagers',
    'PoliciesManagers',
    'SettingsManagers',
    'AdvancedSettingsManagers',
    'SecurityReportsManagers',
    'AssessmentManagers',
    'AwarenessContentManagers',
    'GamificationManagers',
    'SurveyManagers',
    'SystemLogsManagers',
    'Users',
  ],

  /** ViewBag.FeatureSets — empty means the license grants every module. */
  features: [],

  /** The Settings rows the layout reads directly. */
  settings: {
    ActivateInvitations: 'true',
    AdminPanelUserManualUrl: 'https://rawam-demo.com/docs',
    WebsiteFooterText: 'مركز التميز لأمن المعلومات',
    LogoBackgroundEnabled: 'true',
  },
})

/** WebConfigReader.BuildVersion — appsettings.json of CoEIA.Rawam.UICore. */
export const buildVersion = '6.3.0'
